import { logEvent } from "firebase/analytics";
import { analytics } from "./index";

// no-op si analytics n'est pas initialisé (dev/staging/emulator).
// Voir firebase/index.js : analytics ne s'initialise qu'en MODE production.
const sanitize = (params) =>
  Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== undefined && v !== null));

export function track(eventName, params = {}) {
  if (!analytics) return;
  try {
    logEvent(analytics, eventName, sanitize(params));
  } catch (err) {
    console.warn("[analytics] event failed", eventName, err);
  }
}

// Event suivi d'un départ vers une autre page (ex : lien Stripe, Recette
// 27/09 : click_order signalé perdu). On navigue au rappel de gtag
// (event_callback), au plus tard après `maxWait` ms : le clic n'est jamais
// bloqué si GA ne répond pas. Mesuré le 27/09 : le rappel arrive en ~10 ms,
// gtag met l'event en lot et le vide au déchargement en fetch keepalive.
// PAS de transport_type : GA4 le remonte comme paramètre (ep.transport_type).
export function trackThenNavigate(eventName, params, go, maxWait = 300) {
  let parti = false;
  const partir = () => {
    if (parti) return;
    parti = true;
    go();
  };
  if (!analytics) return partir();
  setTimeout(partir, maxWait);
  try {
    logEvent(analytics, eventName, {
      ...sanitize(params),
      event_callback: partir,
    });
  } catch (err) {
    console.warn("[analytics] event failed", eventName, err);
    partir();
  }
}

// Helper: derive les params communs scan à partir du state du store scan.
// Tous les events scan_* doivent passer ce payload pour que les KPI POC
// (coef viral, expansion réseau, circulation jeton) soient mesurables.
export function scanParams({
  token,
  animax,
  scanState,
  scanCount,
  firstScan,
  currentUid,
  entryPoint = "in_app",
}) {
  const isOwner =
    scanState === "owned" || scanState === "unclaimed"; // unclaimed → user becomes owner on arrival
  return {
    token_id: token?.id || null,
    animal_id: animax?.id || null,
    animal_name: animax?.name || null,
    rareness: animax?.rareness || null,
    scan_state: scanState || null,
    is_owner: isOwner,
    scan_count_before_visit: scanCount ?? 0,
    owner_uid: firstScan?.uid || (isOwner ? currentUid : null),
    entry_point: entryPoint,
  };
}
